var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalNavigation = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@wheelroom/core");
exports.LegalNavigation = (props) => {
    if (props.hideLegal) {
        return null;
    }
    return (react_1.default.createElement(core_1.Flex, { is: 'div', wheel: props.wheel },
        !props.hideCopyright && (react_1.default.createElement(core_1.Any, { is: "span", polyPreset: false, wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.copyright }) }, props.copyright)),
        props.supportWheelroom && (react_1.default.createElement(core_1.Any, { is: "span", polyPreset: false, wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.promise }) },
            react_1.default.createElement(core_1.ALink, { href: props.siteMetadata.legal.url, wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.promise.link }) }, props.siteMetadata.legal.description),
            react_1.default.createElement(core_1.Sup, { wheel: Object.assign(Object.assign({}, props.wheel), { style: props.wheel.style.promise.sup }) }, ' ' + props.siteMetadata.legal.version)))));
};
//# sourceMappingURL=legal-navigation.js.map